export const QUERY_FOR_AB_TEST_GROUP = 'QUERY_FOR_AB_TEST_GROUP';
